export default __webpack_public_path__ + "static/media/gfg.2314a2f6.svg";